import { useState } from 'react';
import i18n from '@signavio/i18n';
import { DangerDialog, Input, useStyles } from '@signavio/ui';
import { isEnter } from '../utils/KeyUtils';
import ConfirmCode from './ConfirmCode';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function RemoveModal({
  onCancel,
  onConfirm,
  nameOfItemToRemove,
  title,
  children
}) {
  const [confirmationText, setConfirmationText] = useState('');
  const [isValid, setIsValid] = useState(false);
  const styles = useStyles({
    lineHeight: '2em'
  }, {});
  return /*#__PURE__*/_jsxs(DangerDialog, {
    title: title,
    disableConfirm: !isValid,
    confirmLabel: i18n('Delete'),
    cancelLabel: i18n('Cancel'),
    onConfirm: onConfirm,
    onCancel: onCancel,
    children: [children, /*#__PURE__*/_jsx("p", {
      ...styles,
      children: i18n('This action cannot be undone! To delete, type __word__ to confirm', {
        word: /*#__PURE__*/_jsx(ConfirmCode, {
          children: (nameOfItemToRemove || i18n('unnamed')).toLowerCase()
        })
      })
    }), /*#__PURE__*/_jsx(Input
    // Possible exception
    // eslint-disable-next-line jsx-a11y/no-autofocus
    , {
      autoFocus: true,
      "aria-label": i18n('validation text'),
      placeholder: i18n('Type "__confirmationText__" to delete.', {
        confirmationText: (nameOfItemToRemove || i18n('unnamed')).toLowerCase()
      }),
      value: confirmationText,
      onChange: value => {
        setConfirmationText(value);
        setIsValid(value === (nameOfItemToRemove || i18n('unnamed')).toLowerCase());
      },
      onKeyDown: event => {
        if (isEnter(event) && isValid) {
          onConfirm();
        }
      }
    })]
  });
}
export default RemoveModal;